export class Rotation {
  constructor(public x: number,
              public y: number,
              public z: number) {
  }
}


// WEBPACK FOOTER //
// ./src/app/classes/rotation.ts